
/**
 * 강의 난이도
 */
export type GetCourses200CoursesItemLevel = typeof GetCourses200CoursesItemLevel[keyof typeof GetCourses200CoursesItemLevel];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCourses200CoursesItemLevel = {
  BEGINNER: 'BEGINNER',
  INTERMEDIATE: 'INTERMEDIATE',
  ADVANCED: 'ADVANCED',
  ALL: 'ALL',
} as const;
